import classNames from 'classnames';
import { memo } from 'react';
import { ForeignTripCard as ForeignTripCardType } from '../foreignTripIndex';
import styles from './ForeignTripCard.module.scss';

type ForeignTripCardProps = {
  card: ForeignTripCardType;
  left: string;
  width: string;
};

/**
 * Eine Klassenfahrt aus einem fremden aktiven Plan.
 *
 * Bewusst keine `GridCard`: Sie ist nicht aufnehmbar, nicht verschiebbar und nicht anklickbar,
 * und sie liegt hinter den eigenen Karten der Zeile — so bleiben die eigenen Karten lesbar und
 * die Fahrt scheint nur dort durch, wo die Zeile frei ist. `memo`, weil der Index nach dem
 * Store-Aufbau unverändert bleibt.
 *
 * Die globale Klasse `foreign-trip-card` ist der Hook für `TeachingBlockGrid`, um die Karte
 * bei einem aufgenommenen Pick per `pointer-events: none` durchklickbar zu machen (siehe dort).
 */
export const ForeignTripCard = memo(({ card, left, width }: ForeignTripCardProps) => {
  return (
    <div
      className={classNames(styles['foreign-trip-card'], 'foreign-trip-card')}
      style={{ left, width }}
      title={card.tooltip}
    >
      <span className={styles.label}>
        {card.subjectShort}
        {card.classesShort ? ` · ${card.classesShort}` : ''}
      </span>
    </div>
  );
});

ForeignTripCard.displayName = 'ForeignTripCard';
